import { React, useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../api/api";
import {
  createGallery,
  fetchGallery,
} from "../../../features/gallerySlice/gallerySlice";
import Images from "../../../media/images";
import ViewGallery from "./ViewGallery";
// import { toast, ToastContainer } from "react-toastify";

const Gallery = () => {
  const { register, handleSubmit, setValue } = useForm();
  const { register: register1, handleSubmit: handleSubmit1 } = useForm();
  const [deletePhoto, setDeletePhoto] = useState(false)
  const [gallery, setGallery] = useState([])
  const [ab, setAb] = useState(false)
  const dispatch = useDispatch();
  const [categoryName, setCategoryName] = useState([])
  const [subCategoryName, setSubCategoryName] = useState([])
  const [galleryId, setGalleryId] = useState({})
  const [imageCategory, setImageCategory] = useState(null)
  const [videoCategory, setVideoCategory] = useState(null)

  // const gallery = useSelector((state) => state.gallery?.data);

  // useEffect(() => {
  //   dispatch(fetchGallery());
  // }, [dispatch,deletePhoto]);

  useEffect(() => {
    api
      .get("/gallery/media/")
      .then((response) => {

        setGallery(response.data)
      })
      .catch((error) => {
        toast("Something wnet wrong")
      })

  }, [deletePhoto, ab])



  // submit image
  const onSubmitImage = async (data) => {

    console.log(data)
    const formData = new FormData();
    formData.append("name", data.img_name);
    formData.append("image", data.image[0]);
    formData.append("category", data.category1);
    formData.append("sub_category", data.sub_category);
    formData.append("media_type", "IM");
    // dispatch(createGallery(formData));

    api.post("/gallery/media/", formData)
      .then(response => {
        toast.success("Data Registered Successfully")
        setAb(!ab)
      }).catch(error => {
        toast.error("Something went wrong")
      })

    // dispatch(fetchGallery())
  };
  // submit video
  const onSubmitVideo = (data) => {

    console.log(data.category)

    const formData = new FormData();
    formData.append("name", data.video_name);
    formData.append("video_url", data.video);
    formData.append("category", data.category);
    formData.append("sub_category", data.sub_category);
    formData.append("media_type", "VI");
    // dispatch(createGallery(formData));
    api.post("/gallery/media/", formData)
      .then(response => {
        toast.success("Media Registered Successfully")
        setAb(!ab)
      }).catch(error => {
        toast.error("Something went wrong")
      })

    // dispatch(fetchGallery());
  };


  const handleDelete = (id) => {


    api
      .delete(`/gallery/media/${id}/`)
      .then((res) => {
        setDeletePhoto(!deletePhoto)
        toast.success("Media Deleted Successfully");
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong");
      });
  }
  useEffect(() => {

    api
      .get("/gallery/media/categories/")
      .then((resp) => {
        setCategoryName(resp.data)
      })
      .catch((error) => {
        toast("Something went wrong")
      })

  }, [])


  useEffect(() => {
    api
      .get(`/gallery/media/sub-categories/`)
      .then((resp) => {
        setSubCategoryName(resp.data)
      })
      .catch((error) => {
        toast("Something went wrong")
      })
  }, [])


  





  return (
    <div className="">
      {gallery.errorMessage && toast.error(gallery.errorMessage)}

      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Gallery

      </h1>
      <Helmet>
        <title>Gallery</title>
        <meta name='title' content='Gallery' />
      </Helmet>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      {/* photos section */}
      {/* <form onSubmit={handleSubmit(onSubmitImage)} className="w-full md:px-10"> */}
      <div className="w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <form onSubmit={handleSubmit(onSubmitImage)}>
                <div className="wrapper overflow-auto">
                  {/* search */}
                  <p className="text-primary-red mt-5 text-center text-xl font-bold underline">
                    Photo Gallery
                  </p>
                  <input
                    placeholder="Upload Photo"
                    type="file"
                    name=""
                    className="text-primary-blue file:bg-primary-red ml-3 outline-none file:rounded-lg file:text-white"
                    id=""
                    {...register("image", { required: true })}
                  />

                  <div className="mt-3 flex items-center justify-between gap-4">
                    <input
                      type="text"
                      placeholder="Photo Name"
                      name=""
                      className="border-primary-blue rounded-md border px-2 py-2"
                      defaultValue=""
                      {...register("img_name", { required: false })}
                    />
                    <div className="border-primary-blue text-primary-blue  rounded-md border px-2 py-2" >
                      <label
                        htmlFor=""> Category</label>
                      <select
                        {...register("category1")}

                      >

                        {
                          categoryName?.map((item, index) => {
                            return (
                              <option value={item.slug}>{item.name}</option>
                            )
                          })
                        }
                      </select>
                    </div>
                    {/* <div className="border-primary-blue text-primary-blue  rounded-md border px-2 py-2" >
                      <label
                        htmlFor="">Select Sub Category</label>
                      <select 
                      {...register("sub_category", { required: false })}
                      
                      >
                        {
                          categoryName?.map((item,index)=>{
                            return(
                              <option value="">{item.name}</option>

                            )
                          })
                        }
                      </select>
                    </div> */}

                    {/* <input
                      type="text"
                      placeholder="Main Cateogry"
                      name="category"
                      className="border-primary-blue rounded-md border px-2 py-2"
                      // defaultValue=""

                p      {...register("category", { required: true })}
                    /> */}




                    <div className="border-primary-blue text-primary-blue  rounded-md border px-2 py-2" >
                      <label
                        htmlFor="">Sub Category</label>
                      <select
                        {...register("sub_category")}

                      >

                        {
                          subCategoryName?.map((item, index) => {
                            return (
                              <option value={item.slug}>{item.name}</option>
                            )
                          })
                        }
                      </select>
                    </div>

                    {/* <input
                    type="submit"
                    value="Sm1"
                    className="bg-primary-green ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold cursor-pointer text-white"
                  /> */}

                    <button
                      type="submit"
                      className="bg-primary-green ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold cursor-pointer text-white"
                    >
                      Submited
                    </button>
                  </div>
                </div>
              </form>
              <table className="common mt-5 w-full border-collapse text-center">
                <thead className="font-Bree bg-primary-red text-lg font-bold">
                  <tr>
                    <th
                      scope="col"
                      className="!w-[20px] px-4 py-4 text-sm font-medium text-white"
                    >
                      SN.
                    </th>
                    <th
                      scope="col"
                      className="py-4 text-sm font-medium text-white"
                    >
                      Photo Name
                    </th>
                    <th
                      scope="col"
                      className="py-4 text-sm font-medium text-white"
                    >
                      Main category
                    </th>
                    <th
                      scope="col"
                      className="py-4 text-sm font-medium text-white"
                    >
                      Sub category
                    </th>
                    <th
                      scope="col"
                      className="py-4 text-sm font-medium text-white"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="font-Acme">
                  {gallery.length > 0 ?
                    gallery?.filter((item) => item.media_type === "IM")
                      .map((item, i) => {


                        return (
                          <tr className="trow border-b bg-white">
                            <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                              {i + 1}
                            </td>
                            <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                              {item.name}
                            </td>
                            <td className="whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                              {item.category.name}
                            </td>
                            <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                              {item.sub_category.name}
                            </td>
                            <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                              <button
                              onClick={()=>setGalleryId(item)}
                                 data-bs-toggle="modal"
                                 data-bs-target="#exampleModalEdit"
                                className="bg-primary-green rounded-full p-1 px-2 text-white"
                              >
                                View
                              </button>
                              <ViewGallery galleryId={galleryId}/>
                      
                              <button
                                onClick={() => handleSubmit(handleDelete(item.id))}

                                className="bg-primary-green rounded-full p-1 px-2 text-white"
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        );
                      }) :
                    <h2>No Data</h2>
                  }
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
      {/* video section */}
      <form onSubmit={handleSubmit1(onSubmitVideo)} className="w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="wrapper overflow-auto">
                <div>
                  {/* search */}
                  <p className="text-primary-red mt-5 text-center text-xl font-bold underline">
                    Video Gallery
                  </p>
                  <input
                    placeholder="Upload video url"
                    type="text"
                    name=""
                    className="text-primary-blue border p-2 file:bg-primary-red ml-3 outline-none file:rounded-lg file:text-white"
                    id=""
                    {...register1("video", { required: true })}
                  />
                  <div className="mt-3 flex items-center justify-between gap-4">
                    <input
                      type="text"
                      placeholder="Video Name"
                      name=""
                      className="border-primary-blue rounded-md border p-2"
                      defaultValue=""
                      {...register1("video_name", { required: true })}
                    />
                    <div className="border-primary-blue text-primary-blue  rounded-md border px-2 py-2" >
                      <label
                        htmlFor=""> Category</label>
                      <select
                        {...register1("category", { required: false })}

                      >
                        <option selected="">select</option>
                        {
                          categoryName?.map((item, index) => {
                            return (
                              <>
                                <option value={item.slug}>{item.name}</option>
                              </>
                            )
                          })
                        }
                      </select>
                    </div>

                    <div className="border-primary-blue text-primary-blue  rounded-md border px-2 py-2" >
                      <label
                        htmlFor="">Sub Category</label>
                      <select
                        {...register1("sub_category")}

                      >

                        {
                          subCategoryName?.map((item, index) => {
                            return (
                              <option value={item.slug}>{item.name}</option>
                            )
                          })
                        }
                      </select>
                    </div>


                    <input
                      type="submit"
                      value="Submit"
                      // onClick={handleSubmit(onSubmitVideo)}
                      className="bg-primary-green ml-10 inline-flex gap-2 rounded-md cursor-pointer px-5 py-3 font-bold text-white"
                    />
                    {/* Submit */}
                    {/* </input> */}
                  </div>
                </div>
                <table className="common mt-5 w-full border-collapse text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="!w-[20px] px-4 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Video Name
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Main category
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Sub category
                      </th>
                      <th
                        scope="col"
                        className="py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {gallery.length > 0 ?
                      gallery?.filter((item) => item.media_type === "VI")
                        .map((item, i) => {


                          return (
                            <tr className="trow border-b bg-white">
                              <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                                {i + 1}
                              </td>
                              <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                                {item.name}
                              </td>
                              <td className="whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                                {item.category.name}
                              </td>
                              <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                                {item.sub_category.name}
                              </td>
                              <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                                <button
                                         onClick={()=>setGalleryId(item)}
                                         data-bs-toggle="modal"
                                         data-bs-target="#exampleModalEdit"
                                  className="bg-primary-green rounded-full p-1 px-2 text-white"
                                >
                                  View
                                </button>
                              
                                <button
                                  onClick={() => handleSubmit(handleDelete(item.id))}

                                  className="bg-primary-green rounded-full p-1 px-2 text-white"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          );
                        }) :
                      <h2>No Data</h2>
                    }
                  </tbody>
                  {/* <tbody className="font-Acme">
                    <tr className="trow border-b bg-white">
                      <td className="w-[5px] whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        1
                      </td>
                      <td className="whitespace-nowrap border border-slate-700 py-3 px-6 text-sm font-light leading-[0px] text-gray-900">
                        Staff group photo
                      </td>
                      <td className="whitespace-nowrap border border-slate-700 text-sm font-light text-gray-900">
                        Office photo
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        for calender 2079
                      </td>
                      <td className="w-[200px] whitespace-nowrap border border-slate-700 p-0 text-sm font-light text-gray-900">
                        <a
                          href=""
                          className="bg-primary-green rounded-full p-1 px-2 text-white"
                        >
                          View
                        </a>
                        <a
                          href=""
                          className="bg-primary-red rounded-full p-1 px-2 text-white"
                        >
                          Download
                        </a>
                        <a
                          href=""
                          className="bg-primary-blue rounded-full p-1 px-2 text-white"
                        >
                          Print
                        </a>
                        <a
                          href=""
                          className="bg-primary-green rounded-full p-1 px-2 text-white"
                        >
                          Delete
                        </a>
                      </td>
                    </tr>
                  </tbody> */}
                
                </table>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Gallery;
